import React from "react";
import { Box, Flex, Image } from "@chakra-ui/react";
import { Viewer } from "../../components/Viewer";
import { useQViewer } from "../QViewerPage/useQViewer";
import { QSetHeader } from "../../components/QSetHeader";
import { AIChat } from "../../components/AIChat";
import { QuestionProgress } from "../../components/QuestionProgress";
import { StopwatchIcon } from "../../components/Icons/StopwatchIcon";


export const QViewerReviewPage = ({ user, loadingCallback, loading }) => {
  const {
    selectedDyno,
    effectiveUserId,
    qSetId,
    requestStores,
    lastAttemptedDynoId,
    submissionCallback,
    dynoLoading,
    currentQSetDynoIndex,
    onChangeDyno,
    navigateToHome,
    disableNext,
    disablePrev,
    askAI,
    chatLoading,
    toggleChat,
    toggleAIChat,
    followUpQuestions,
    chat,
    askFollowUPQuestion,
    askFirstQuestion,
    onReview,
    regenerate,
    openModal,
    closeModal,
    feedback,
    setFeedback,
    submitFeedback,
    feedbackResponse,
    hasReachedMaxLimit,
    dynoIdList
  } = useQViewer({ user, loadingCallback, isReview: true });
  const userInfo = { ...user, id: effectiveUserId };
  const min = Math.floor(selectedDyno?.mySubmission?.timeTaken / 60);
  const sec = selectedDyno?.mySubmission?.timeTaken - min * 60;
  return (
    <>
      <QSetHeader
        onChangeDyno={onChangeDyno}
        navigateToHome={navigateToHome}
        disableNext={disableNext}
        disablePrev={disablePrev}
      >
        {!loading && !dynoLoading && (
          <>
            <QuestionProgress current={currentQSetDynoIndex} total={dynoIdList.length} />
            <Box className="time-stat">
              <StopwatchIcon className="time-stat__icon" />
              <span className="time-stat__label">Time taken</span>
              <span>
                <span className="timer-text">{min}</span> Min{" "}
                <span className="timer-text">{sec}</span> Sec
              </span>
            </Box>
          </>
        )}
      </QSetHeader>
      {dynoLoading && (
        <Box className="overlay-loader">
          <Image src="/images/ninja.gif" width="100px" height= "100px"/>
        </Box>
      )}
      <Flex width="100%" alignItems="flex-start">
        <Flex width="100%" minWidth={0} className="review-page parent-wrap">
          {!loading && !dynoLoading && (
            <Box
              className={
                selectedDyno.myDyno &&
                selectedDyno.myDyno.info.dyno_type === "Practice"
                  ? "practice-dyno"
                  : "common-dyno"
              }
            >
              {selectedDyno?.myDyno?._id && (
                <Viewer
                  selectedDyno={selectedDyno}
                  requestStores={requestStores}
                  userInfo={userInfo}
                  submissionCallback={submissionCallback}
                  lastAttemptedDynoId={lastAttemptedDynoId}
                  qSetId={qSetId}
                />
              )}
            </Box>
          )}
        </Flex>
        <AIChat
          askAI={askAI}
          chatLoading={chatLoading}
          chat={chat}
          toggleChat={toggleChat}
          toggleAIChat={toggleAIChat}
          followUpQuestions={followUpQuestions}
          askFollowUPQuestion={askFollowUPQuestion}
          onReview={onReview}
          openModal={openModal}
          closeModal={closeModal}
          regenerate={regenerate}
          feedback={feedback}
          setFeedback={setFeedback}
          submitFeedback={submitFeedback}
          feedbackResponse={feedbackResponse}
          askFirstQuestion={askFirstQuestion}
          hasReachedMaxLimit={hasReachedMaxLimit}
          dockOffset={184} // below the page header and the sticky Prev/Next bar
        />
      </Flex>
    </>
  );
};
